var render = function () {
  var _vm$sheet, _vm$sheet2, _vm$sheet3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', {
    staticClass: "w100"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_vm.$store.getters['authenticationStorage/isAuthenticated'] ? _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('font-awesome-icon', {
    staticClass: "arrow-left",
    attrs: {
      "icon": "arrow-left"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/dashboard');
      }
    }
  })], 1) : _vm._e(), _c('b-col', {
    staticClass: "mr-auto",
    attrs: {
      "cols": "auto"
    }
  }, [_c('h1', [_vm._v(" " + _vm._s((_vm$sheet = _vm.sheet) === null || _vm$sheet === void 0 ? void 0 : _vm$sheet.name) + " ")])]), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm.$store.getters['authenticationStorage/isAuthenticated'] ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.invite-modal",
      modifiers: {
        "invite-modal": true
      }
    }]
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.invite')) + " ")]) : _vm._e(), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.newnewPdf(_vm.sheet);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.pdf.download')) + " ")])], 1)], 1), _c('b-row', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-col', [_c('h4', [_vm._v(_vm._s((_vm$sheet2 = _vm.sheet) === null || _vm$sheet2 === void 0 ? void 0 : _vm$sheet2.eventName))])])], 1), _c('b-row', [_c('b-col', [_c('toggleable-text', {
    attrs: {
      "text": (_vm$sheet3 = _vm.sheet) === null || _vm$sheet3 === void 0 ? void 0 : _vm$sheet3.description
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }